<template>
  <div id="calc" class="container">
    <div class="row">
      <div class="col">
        <div class="card h-100 bg-transparent border-0">
          <div class="card-body">
            <form>
              <div class="form-group brand-select">
                <label for="loantype">Loan Type</label>
                <select class="form-control form-control border-top-0 border-right-0 border-left-0" id="loantype" aria-describedby="typeHelp" v-model="selected" @@change="changeType">
                  <option v-for="(type, key) in types" :key="key" :class="{'active': type.value == type }" v-bind:value="type.value">{{ type.text }}</option>
                </select>
                <small id="typeHelp" class="form-text text-muted">Read more about <a href="https://www.mortgagecalculator.net/types-of-mortgages/" target="_blank">loan types</a></small>
              </div>
              <div class="form-group">
                <label for="price">Home Price</label>
                <input type="text" class="form-control border-top-0 border-right-0 border-left-0" id="price" aria-describedby="priceHelp" v-model="price" @@keyup="checkPrice" @@blur="onBlurPrice">
                <small id="priceHelp" class="form-text text-muted">The selling price of the property.</small>
              </div>
              <div class="form-group">
                <label for="upfront" class="d-flex justify-content-between align-items-center">Down Payment ({{ upfront }}%) <small class="text-muted text-right" v-html="toCurrency(down, 0)"></small></label>
                <input type="range" class="form-control-range border-top-0 border-right-0 border-left-0" :min="selected == 1 ? 3.5 : 0" step="0.5" max="100" id="upfront" v-model="upfront">
                <small id="upfrontHelp" class="form-text text-muted">The percentage of your home's purchase price that is paid upfront.</small>
              </div>

              <div class="form-group">
                <label for="rate">Interest Rate <i class="fas fa-question-circle" v-b-tooltip.hover.html="tipMethod(5)"></i></label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text border-top-0 border-right-0 border-left-0" id="btnGroupAddon">%</div>
                  </div>
                  <input type="text" class="form-control border-top-0 border-right-0 border-left-0" id="rate" aria-describedby="rateHelp" v-model.lazy="rate" @keyup.enter="checkRate" @@blur="checkRate">
                </div>
                <small id="rateHelp" class="form-text text-muted">The interest rate your banking establishment charges for use of their assets.</small>
              </div>
              <div class="form-group">
                <label for="term">Loan Term</label>
                <div id="term" class="input-group btn-group btn-group-toggle" data-toggle="buttons" aria-descibedby="termHelp">
                  <label v-for="(options, key) in terms" :key="key" class="btn brand-bg-secondary text-white" :class="{'active': options.value == term }">
                    <input type="radio" name="options" :id="options.value" :value="options.value" v-model="term" :checked="options.value == term">{{ options.text.replace(' year fixed', '') }} <span class="d-none d-lg-inline">yr</span>
                  </label>
                </div>
                <small id="termHelp" class="form-text text-muted">The number of years.</small>
              </div>
            </form>
          </div>
          <button class="btn btn-light d-flex justify-content-between align-items-center" type="button" @click="visible = !visible" :aria-expanded="visible" aria-controls="collapseDetails">
            Annual Summary
            <b-icon-chevron-up v-if="visible"></b-icon-chevron-up>
            <b-icon-chevron-down v-else></b-icon-chevron-down>
          </button>
          <Transition>
            <div id="collapseDetails" :class="visible === false ? ' collapse' : ''">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <small class="w-100 d-flex justify-content-between align-items-center">Total payments <small class="text-muted">{{ months }} monthly payments</small></small>
                </li>
                <li class="list-group-item">
                  <small class="w-100 d-flex justify-content-between align-items-center">Down payment ({{ upfront }}%) <small class="text-muted">{{ toCurrency(down, 0) }}</small></small>
                </li>
                <li class="list-group-item">
                  <small class="w-100 d-flex justify-content-between align-items-center">Principal <small class="text-muted">{{ toCurrency(loan, 0) }}</small></small>
                </li>
                <li class="list-group-item">
                  <small class="w-100 d-flex justify-content-between align-items-center">Total interest paid <small class="text-muted">{{ toCurrency(interest, 0) }}</small></small>
                </li>
                <li class="list-group-item">
                  <small class="w-100 d-flex justify-content-between align-items-center">Total mortgage cost* <small class="text-muted">{{ toCurrency(total, 0) }}</small></small>
                </li>
                <li class="list-group-item">
                  <small class="font-weight-light font-italic">*Estimated, not including taxes and insurance.</small>
                </li>
              </ul>
            </div>
          </Transition>
        </div>
      </div>
      <div class="col">
        <div class="card h-100 bg-transparent border-0">
          <div class="card-img-top">
            <div id="chart-wrapper" class="cZYPTi" style="position: relative; max-width: 100%; margin: 0px auto 48px;">
              <canvas id="dvbChart"></canvas>
<!--              <doughnut-chart :key="this.chartData.labels.length" :chartData="chartData"></doughnut-chart>-->
              <div class="details guTAgF" style="font-weight: 600; font-size: 28px; text-align: center; line-height: 60px; position: absolute; display: block; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                <div v-html="toCurrency(payment)"></div>
                <h6>Monthly Payment</h6>
              </div>
            </div>
          </div>

          <ul id="bobby" class="list-group list-group-flush">
            <li class="list-group-item d-flex w-100 justify-content-between align-items-center row-cols-2 px-0">
              <h6 class="col-sm-8">
                <i class="fas fa-circle pr-2" :style="'color:'+this.colorsArray[0]+';'"></i> Principal & Interest <i class="fas fa-question-circle" v-b-tooltip.hover.focus.html="tipMethod(0)"></i>
              </h6>
              <div class="col-sm-4">
                <div v-html="toCurrency(pandi, 0)"></div>
              </div>
            </li>
            <li class="list-group-item d-flex w-100 justify-content-between align-items-center row-cols-2 px-0">
              <h6 class="col-sm-8"><i class="fas fa-circle pr-2" :style="'color:'+this.colorsArray[1]+';'"></i> Property Taxes <i class="fas fa-question-circle" v-b-tooltip.hover.html="tipMethod(1)"></i></h6>
              <div class="col-sm-4">
                <input type="text" class="form-control-plaintext border-bottom" v-model.lazy="taxes" @@keyup.enter="checkValue(taxes)" @@blur="checkValue(taxes)">
              </div>
            </li>
            <li class="list-group-item d-flex w-100 justify-content-between align-items-center row-cols-2 px-0">
              <h6 class="col-sm-8"><i class="fas fa-circle pr-2" :style="'color:'+this.colorsArray[2]+';'"></i> HOI <i class="fas fa-question-circle" v-b-tooltip.hover.html="tipMethod(2)"></i></h6>
              <div class="col-sm-4">
                <input type="text" class="form-control-plaintext border-bottom" id="homeIns" v-model.lazy="homeIns" @@keyup.enter="checkValue(homeIns)" @@blur="checkValue(homeIns)">
              </div>
            </li>
            <li class="list-group-item d-flex w-100 justify-content-between align-items-center row-cols-2 px-0">
              <h6 class="col-sm-8"><i class="fas fa-circle pr-2" :style="'color:'+this.colorsArray[3]+';'"></i> HOA Dues <i class="fas fa-question-circle" v-b-tooltip.hover.html="tipMethod(3)"></i></h6>
              <div class="col-sm-4">
                <input type="text" class="form-control-plaintext border-bottom" id="homeAss" v-model.lazy="homeAss" @@keyup.enter="checkValue(homeAss)" @@blur="checkValue(homeAss)">
              </div>
            </li>
            <li class="list-group-item d-flex w-100 justify-content-between align-items-center row-cols-2 px-0">
              <h6 class="col-sm-8"><i class="fas fa-circle pr-2" :style="'color:'+this.colorsArray[4]+';'"></i> PMI <i class="fas fa-question-circle" v-b-tooltip.hover.html="tipMethod(4)"></i></h6>
              <div class="col-sm-4">
                <input type="text" class="form-control-plaintext border-bottom" id="homePmi" v-model.lazy="homePmi" @@keyup.enter="checkValue(homePmi)" @@blur="checkValue(homePmi)">
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="showSidebar" class="col-12 col-lg-3 d-none d-sm-inline">
        <div class="card h-100 border-0">
          <div class="card-body">
            <div class="card text-center rounded-0 brand-bg-tertiary brand-text-primary">
              <div class="card-body">
                <p class="card-text lead">{{ sidebarText }}</p>
              </div>
            </div>
          </div>
          <div class="card-footer bg-transparent border-0">
            <a class="btn text-uppercase rounded-0 button-blue text-white text-decoration-none" style="min-width: unset;" @click="created()">{{ btnText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconChevronDown, BIconChevronUp, VBTooltip } from 'bootstrap-vue'
import Chart from 'chart.js';
export default {
  name: "MortgageCalculator",
  components: {
    // DoughnutChart,
    //BIconCircleFill,
    BIconChevronDown,
    BIconChevronUp,

  },
  directives: {
    'v-b-tooltip': VBTooltip
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    sidebarTitle: {
      type: String,
      default: function () {
        return '';
      }
    },
    sidebarText: {
      type: String,
      default: function () {
        return '';
      }
    },
    sidebarColor: {
      type: String,
      default: function () {
        return '#a5afcf';
      }
    },
    btnText: {
      type: String,
      default: function () {
        return 'Find a Loan Officer';
      }
    },
    btnTextColor: {
      type: String,
      default: function () {
        return '#a5afcf';
      }
    },
    producturl: {
      type: String,
      default: function () {
        return '';
      }
    },
    colors: {
      type: String,
      default: function () {
        return '#002248,#29b6f6,#b3e5fc,#01579b,#667A91';
      }
    }
  },
  data() {
    return {
      output: null,
      price: '$250,000',
      upfront: 20,
      baserate: 6,
      rate: 6,
      term: 30,
      terms: [
        { text: '15 year fixed', value: 15 },
        { text: '20 year fixed', value: 20 },
        { text: '30 year fixed', value: 30 }
      ],
      selected: 0,
      types: [
        { text: 'Conventional', value: 0, add: 0 },
        { text: 'FHA Loan', value: 1, add: 0.75 },
        { text: 'VA Loan', value: 2, add: -0.5 },
        { text: 'ARM Loan', value: 3, add: 0.5 },
        { text: 'Jumbo Loan', value: 4, add: -1.3 }
      ],
      taxes: '$156',
      principleInterest: '$0',
      homeIns: '$135',
      homeAss: '$0',
      homePmi: '$0',
      visible: false,
      animate: false,
      button: 'Save Settings'
    }
  },
  mounted() {
    this.buildChart();
  },
  watch: {
    'chartData': {
      handler() {
        this.buildChart()
      },
      deep: true
    }
  },
  methods: {
    buildChart() {
      const ctx = document.getElementById("dvbChart").getContext("2d");
      new Chart(ctx, {
        type: 'doughnut',
        data: this.chartData,
        options: this.options()
      });
    },
    tipMethod(key) {
      switch (key) {
        case 0:
          return "<h5>Principal and Interest</h5><p>Your mortgage principal is the total amount you've borrowed from a lender to buy a home. Interest is the fee lenders charge you for borrowing their money; usually, an annual percentage rate.</p>"
        case 1:
          return "<h5>Property Taxes</h5><p>Any tax on real estate or certain other forms of property.</p>"
        case 2:
          return "<h5>Homeowners Insurance</h5><p>Financial protection that you purchase from an insurance provider. It helps pay for losses if a covered disaster or other damaging event affects your home.</p>"
        case 3:
          return "<h5>Homeowner’s Association (HOA) fee</h5><p>Monthly or quarterly fee assessed by the HOA to pay for the services that it provides.</p>"
        case 4:
          return "<h5>Private Mortgage Insurance (PMI)</h5><p>Insurance policy that compensates lenders for losses from a mortgage loan default.</p>"
        case 5:
          return "<h5>Interest Rate</h5> <p>Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics.</p>"
        default:
          return ''
      }
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    linkOut() {
      window.location.href = this.producturl
    },
    created() {
      // POST request using fetch with set headers
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Accept-Encoding': 'gzip, deflate',
          'Connection': 'keep-alive',
          'Content-Length': '24',
          'User-Agent': 'python-requests/2.26.0'
        },
        body: JSON.stringify({
          title: 'POST from TBM Calculator',
          price: this.price,
          upfront: this.upfront,
          down: this.toCurrency(this.down, 0),
          rate: this.rate,
          term: this.term,
          taxes: this.taxes,
          homeIns: this.homeIns,
          homeAss: this.homeAss,
          homePmi: this.homePmi,
          payment: this.toCurrency(this.pandi, 0)
        })
      };
      //curl -X POST -H 'Accept: */*' -H 'Accept-Encoding: gzip, deflate' -H 'Connection: keep-alive' -H 'Content-Length: 24' -H 'Content-Type: application/json' -H 'User-Agent: python-requests/2.26.0' -d '{"foo": 42, "bar": true}
      fetch(' https://v2.dashagentportal.com/api/v1/submit_financial_data', requestOptions)
          .then(response => response.json())
          .then(data => this.postId = data.id);
    },
    changeType() {
      this.rate = this.baserate;
      let add = this.types.find(type => {
        if (type.value === this.selected) {
          return type;
        }
      });

      this.rate = this.rate + add.add;

    },
    toCurrency(value, cents = 2) {
      // if invalid, return two en dashes
      if (isNaN(value) || !isFinite(value)) return '&ndash;&ndash;';

      // else make it pretty and return
      return '$' + value.toFixed(cents).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toPercent(value, decimals = 3) {
      // if invalid, return two en dashes
      if (isNaN(value) || !isFinite(value)) return '&ndash;&ndash;';

      // else make it pretty and return
      return Number(value).toFixed(decimals) + '%';
    },
    checkRate() {


      // remove non numeric chars (except decimal)
      var value = String(this.rate).replace(/[^0-9.]/g, '');

      // if value is empty or invalid, set to 0
      if (value === '' || isNaN(value)) value = '0';

      // if first char is decimal, add a leading zero
      if (value.charAt(0) === '.') value = '0' + value;



      // update the value (max is 100)
      this.rate = (value < 100) ? value : '100';
    },
    checkPrice() {

      // remove leading zeros and non numeric chars (except decimal)
      var value = String(this.price).replace(/[^0-9.]/g, '').replace(/^0+/, '');

      // limit to no more than 2 decimal places
      if (value.includes('.')) {
        if (value.split('.')[1].length > 2) value = value.slice(0, -1);
      }

      // if the value is invalid, just display dollar sign and return
      if (value == '' || isNaN(value)) {
        this.price = '$';
        return;
      }

      // else make it pretty
      this.price = '$' + String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

    },
    checkValue(proc) {

      // remove leading zeros and non numeric chars (except decimal)
      var value = String(proc).replace(/[^0-9.]/g, '').replace(/^0+/, '');

      // limit to no more than 2 decimal places
      if (value.includes('.')) {
        if (value.split('.')[1].length > 2) value = value.slice(0, -1);
      }

      // if the value is invalid, just display dollar sign and return
      if (value == '' || isNaN(value)) {
        proc = '$';
        return;
      }

      // else make it pretty
      proc = '$' + String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

    },
    onBlurPrice() {

      // if value is less than two chars, set it to '$0'
      if (this.price.length < 2) this.price = '$0';

    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 85,
        tooltips: {
          enabled: true
        },
        legend: {
          display: false,
          onClick: function () { return; },
          position: 'bottom',
          labels: {
            boxWidth: 16,
            fontColor: '#888',
            fontSize: 13
          }
        },
        animation: {
          duration: (this.animate) ? 1000 : 0
        },
        plugins: {
          title: {
            display: false,
            text: 'Custom Chart Title'
          },
        },
      }
    },
  },
  computed: {
    priceInt: function () {
      var price = parseFloat(String(this.price).replace(/[^0-9.]/g, ''));
      return (isNaN(price)) ? 0 : price;
    },

    // down payment = price * (upfront / 100)
    down: function () {
      return this.priceInt * (parseInt(this.upfront) / 100);
    },

    // loan amount = price - down payment
    loan: function () {
      return this.priceInt - this.down;
    },

    // months = term * 12
    months: function () {
      return this.term * 12;
    },
    // monthly payment calc
    pandi: function () {
      var P = this.loan;
      var r = parseFloat(this.rate / 1200);
      var N = parseInt(this.months);
      return (r == 0) ? P / N : P * (r * Math.pow((1 + r), N)) / (Math.pow((1 + r), N) - 1);
    },
    tx: function () {
      return parseFloat(String(this.taxes).replace(/[^0-9.]/g, ''));
    },
    hoi: function () {
      return parseFloat(String(this.homeIns).replace(/[^0-9.]/g, ''));
    },
    hoa: function () {
      return parseFloat(String(this.homeAss).replace(/[^0-9.]/g, ''));
    },
    pmi: function () {
      return parseFloat(String(this.homePmi).replace(/[^0-9.]/g, ''));
    },
    // monthly payment calc
    payment: function () {
      return (this.pandi + this.tx + this.hoi + this.hoa + this.pmi);
    },

    // total mortgage cost = months * monthly payment + down payment
    total: function () {
      return this.months * this.payment + this.down;
    },

    // total interest payable = total cost - down payment - loan amount
    interest: function () {
      return this.total - this.down - this.loan;
    },
    // define chart data
    chartData: function () {
      var data = [100, 0, 0, 0, 0];
      var colors = '#f0f0f0';
      // if price is zero
      if (this.priceInt != 0) {
        // else if price > zero
        data = [this.pandi, this.tx, this.hoi, this.hoa, this.pmi];
        colors = this.colorsArray;
      }

      // return chart data
      return {
        labels: ["Principal & Interest", "Property Taxes", "HOI", "HOA", "PMI"],
        datasets: [{
          backgroundColor: colors,
          borderColor: "#fff",
          borderWidth: 2,
          hoverBackgroundColor: colors,
          hoverBorderColor: "#fff",
          hoverBorderWidth: 2,
          data: data,
          cutout: "85%"
        }]
      };

    },
    colorsArray: function () {
      return this.colors ? this.colors.split(',').map(s => s.trim()) : [];
    }
  }
}
</script>

<style scoped>

</style>
